import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

window.$ = window.jQuery = require('jquery');

import moment from 'moment';
window.moment = moment;

// TODO: add when all consoletv/charts have been replaced with Chart.js
// import Chart from 'chart.js/auto';
// window.Chart = Chart;

// Import JSZip library (used by DataTables Buttons for Excel export)
import JSZip from 'jszip';
// Attach JSZip to the global window object so DataTables export buttons can access it
window.JSZip = JSZip;

// Import pdfMake core and virtual font system (vfs) for PDF export
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Attach font definitions to pdfMake (required for generating PDFs)
pdfMake.vfs = pdfFonts.vfs;
// Make pdfMake available globally (so DataTables buttons can access it)
window.pdfMake = pdfMake;

// Import Lodash utility library (general JS helpers)
window._ = require('lodash');

/**
 * Choose one datatables theme [default, bootstrap5], depending on your setup
 */
// For default theme:
// import './datatables-default.js';
// For Bootstrap 5 theme:
import './datatables-bs5.js';

require('select2');

import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
